module.exports = __webpack_public_path__ + "static/img/Mark.McVeigh.0a57b51.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Mark.McVeigh.jpg
// module id = g6FM
// module chunks = 0